import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Avatar } from "./Avatar";
import { Button } from "./Button";

export function Navbar() {
  const { t } = useTranslation();
  const { user, isLoading } = useAuth();

  function handleSignOut() {
    fetch("/auth/logout", { method: "POST" }).finally(() => {
      window.location.reload();
    });
  }

  return (
    <nav className="fixed top-0 inset-x-0 z-40 bg-white/80 dark:bg-stone-950/80 backdrop-blur border-b border-stone-200/60 dark:border-stone-800/60">
      <div className="h-14 px-6 flex items-center justify-between max-w-4xl mx-auto">
        {/* Left side */}
        <div className="flex items-center gap-5">
          <Link
            to="/"
            className="text-amber-500 font-semibold text-base hover:text-amber-400 transition-colors"
          >
            {t("brand.name")}
          </Link>
          <Link
            to="/leaderboard"
            className="text-stone-500 hover:text-stone-700 dark:hover:text-stone-300 text-sm transition-colors hidden sm:block"
          >
            {t("nav.leaderboard")}
          </Link>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-3">
          {!isLoading &&
            (user ? (
              <>
                <Link
                  to={`/user/${user.id}`}
                  className="flex items-center gap-2 group"
                >
                  <Avatar
                    name={user.name}
                    imageUrl={user.avatar_url}
                    size={28}
                  />
                  <div className="hidden sm:flex flex-col items-start leading-tight">
                    <span className="text-stone-700 dark:text-stone-300 text-sm group-hover:text-stone-900 dark:group-hover:text-stone-100 transition-colors">
                      {user.name}
                    </span>
                    <span className="text-amber-500 text-xs tabular-nums">
                      {t("navbar.voteStats", {
                        used: user.total_vote_credits - user.vote_credits,
                        total: user.total_vote_credits,
                        count: user.total_vote_credits,
                      })}
                    </span>
                  </div>
                </Link>
                <Button
                  variant="ghost"
                  className="text-xs px-3 py-1.5"
                  onClick={handleSignOut}
                >
                  {t("auth.signOut")}
                </Button>
              </>
            ) : (
              <Button
                variant="primary"
                className="text-xs px-3 py-1.5"
                onClick={() => {
                  const returnTo =
                    window.location.pathname + window.location.search;
                  window.location.href = `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
                }}
              >
                {t("auth.signIn")}
              </Button>
            ))}
        </div>
      </div>
    </nav>
  );
}
